import { configureStore } from '@reduxjs/toolkit';

import settingsReducer from './slices/settings.slice';
import teamReducer from './slices/team.slice';

export const store = configureStore({
  reducer: {
    team: teamReducer,
    settings: settingsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
